import React, { useEffect } from "react";
import { Field, reduxForm, change } from "redux-form";
import PropTypes from "prop-types";
import styles from "./ClientCreatePasswordForm.module.scss";
import { validation } from "../../../../../utils";
import EntityNameField from "../../../../common/components/UI/EntityNameField/EntityNameField";
import { bindActionCreators } from "redux";

function ClientCreatePasswordForm({
  onChangePassword,
  refPassword,
  defaultPassword,
  change,
  isPasswordOptional,
  placeholder,
}) {
  useEffect(() => {
    if (defaultPassword) {
      change("password", defaultPassword);
    }
  }, [defaultPassword]);

  return (
    <form className={styles.theaterNameForm}>
      <Field
        ref={refPassword}
        withRef={true}
        name="password"
        type="text"
        isFocusAfterMounted={true}
        component={EntityNameField}
        className={styles.input}
        placeholder={placeholder ? placeholder : `Password`}
        validate={[validation.required]}
        onChange={onChangePassword}
        //normalize={validation.normalizeExtraSpaces}
      />
    </form>
  );
}

ClientCreatePasswordForm.propTypes = {};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ change }, dispatch);
};

export default reduxForm(
  {
    form: "createClientPassword",
    /*enableReinitialize: true,
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: false,*/
  },
  mapDispatchToProps
)(ClientCreatePasswordForm);
